export default class NavbarEnum {
    static BODY = 'body'
    static HEADER = '[data-element="header"]'
    static NAVBAR = '[data-id="wpiris-navbar"]'
    static LOGO = '[data-id="wpiris-logo"]'

    static BURGER_MENU_TRIGGER = '[data-trigger="wpiris-menu-toggle"]'
    static BURGER_MENU_MORE = '[data-trigger="burger-menu-more"]'
    static BURGER_MENU_PREV = '[data-trigger="burger-menu-prev"]'
    static BURGER_SUBMENU = '[data-element="burger-submenu"]'

    static BURGER_LANG_SWITCHER = '[data-element="lang-switcher"]'
    static BURGER_LANG_SWITCHER_TRIGGER = '[data-trigger="lang-switcher"]'
    static BURGER_LANG_SWITCHER_LIST = '[data-element="lang-switcher-list"]'
}
